import { useCallback } from 'react';

import { useCommentsData } from '@confluence/comments-data/entry-points/useCommentsData';
import { useCommentsPanelActions } from '@confluence/comments-panel-utils/entry-points/useCommentsPanel';
import { fg } from '@confluence/feature-gating';
import { useUnreadCommentsActions } from '@confluence/unread-comments/entry-points/useUnreadComments';

import {
	createReadCommentsDataMap,
	getCommentIdsByTypeAndAnnotationId,
} from '../helper/commentHelpers';

export const useSyncReadComments = () => {
	const { setCommentsToBeMarkedAsRead } = useCommentsPanelActions();
	const [{ commentsDataMap }, { setCommentsDataMap }] = useCommentsData();
	const { updateUnreadCommentIDSet } = useUnreadCommentsActions();

	return useCallback(() => {
		if (fg('confluence_frontend_unread_comments_fixes')) {
			// Update the unread comments store when the feature flag is enabled
			updateUnreadCommentIDSet(new Set(), 'removeAll');
		} else {
			setCommentsToBeMarkedAsRead(getCommentIdsByTypeAndAnnotationId(commentsDataMap));
			setCommentsDataMap(createReadCommentsDataMap(commentsDataMap));
		}
	}, [commentsDataMap, setCommentsToBeMarkedAsRead, setCommentsDataMap, updateUnreadCommentIDSet]);
};
